var Position = {
  Left: "left",
  Right: "right",
  Top: "top",
  Bottom: "bottom",
  Mouse: "mouse"
};
export default Position;
